import React from 'react';
import styled from 'styled-components';

/**
 * 목록 페이지네이션 (디자인 공통: 34×34 · radius 17 · 13.5px).
 * 헌혈요청·커뮤니티·공지에서 같은 모양을 쓴다.
 * page는 0-base, 표시는 1-base.
 */
type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  /** 한 번에 보여줄 번호 개수 */
  window?: number;
};

const Pagination = ({ page, totalPages, onChange, window: win = 5 }: Props) => {
  if (!totalPages || totalPages <= 1) return null;

  const half = Math.floor(win / 2);
  let start = Math.max(0, page - half);
  const end = Math.min(totalPages, start + win);
  start = Math.max(0, end - win);
  const numbers = Array.from({ length: end - start }, (_, i) => start + i);

  return (
    <Wrap>
      <Arrow
        disabled={page === 0}
        onClick={() => onChange(page - 1)}
        aria-label="이전 페이지"
      >
        ‹
      </Arrow>
      {numbers.map((n) => (
        <PageButton key={n} active={n === page} onClick={() => onChange(n)}>
          {n + 1}
        </PageButton>
      ))}
      <Arrow
        disabled={page >= totalPages - 1}
        onClick={() => onChange(page + 1)}
        aria-label="다음 페이지"
      >
        ›
      </Arrow>
    </Wrap>
  );
};

const Wrap = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 4px;
`;
const PageButton = styled.button<{ active: boolean }>`
  width: 34px;
  height: 34px;
  border-radius: 17px;
  font-size: 13.5px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ active }) => (active ? 700 : 500)};
  border: 1px solid ${({ active }) => (active ? '#FF4651' : '#E6E6E6')};
  background: ${({ active }) => (active ? '#FF4651' : '#ffffff')};
  color: ${({ active }) => (active ? '#ffffff' : '#767676')};
  &:hover:not(:disabled) {
    border-color: ${({ active }) => (active ? '#FF4651' : '#FF6969')};
    color: ${({ active }) => (active ? '#ffffff' : '#FF4651')};
  }
`;
const Arrow = styled(PageButton).attrs({ active: false })`
  &:disabled {
    color: #d8d8d8;
    border-color: #f0f0f0;
    cursor: default;
  }
`;

export default Pagination;
